module.exports = __webpack_public_path__ + "static/media/line-circle.3568c071.svg";